export default {"src":"/_next/static/media/IQPizza_small.07992a24.svg","height":193,"width":192,"blurWidth":0,"blurHeight":0};